class TestimonialSlider {
  constructor() {
    this.slider = document.querySelector('.testimonial-slider');
    this.slides = document.querySelectorAll('.testimonial-slide');
    this.prevBtn = document.querySelector('.testimonial-prev');
    this.nextBtn = document.querySelector('.testimonial-next');
    this.dotsContainer = document.querySelector('.testimonial-dots');
    this.currentIndex = 0;
    this.slidesPerView = 1;
    this.totalSlides = this.slides.length;
    this.dots = [];
    
    this.init();
  }
  
  init() {
    this.checkScreenSize();
    this.createDots();
    this.setActiveSlide();
    this.addEventListeners();
  }
  
  checkScreenSize() {
    this.slidesPerView = window.innerWidth >= 768 ? 3 : 1;
    this.updateSliderStyles();
  }
  
  updateSliderStyles() {
    const slideWidth = this.slidesPerView === 1 ? '100%' : `calc(33.333% - 1rem)`;
    
    this.slides.forEach(slide => {
      slide.style.flex = `0 0 ${slideWidth}`;
    });
    
    this.setActiveSlide();
  }
  
  createDots() {
    this.dotsContainer.innerHTML = '';
    const maxDots = this.slidesPerView === 1 ? this.totalSlides : this.totalSlides - this.slidesPerView + 1;
    
    for (let i = 0; i < maxDots; i++) {
      const dot = document.createElement('button');
      dot.classList.add('testimonial-dot');
      dot.setAttribute('aria-label', `Aller au témoignage ${i + 1}`);
      
      dot.addEventListener('click', () => {
        this.goToSlide(i);
      });
      
      this.dotsContainer.appendChild(dot);
      this.dots.push(dot);
    }
  }
  
  setActiveSlide() {
    const translateValue = this.slidesPerView === 1 
      ? -this.currentIndex * 100
      : -this.currentIndex * (100 / 3);
    
    this.slider.style.transform = `translateX(${translateValue}%)`;
    
    // Update dots
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentIndex);
    });
  }
  
  nextSlide() {
    const maxIndex = this.slidesPerView === 1 
      ? this.totalSlides - 1 
      : this.totalSlides - this.slidesPerView;
    
    if (this.currentIndex >= maxIndex) {
      this.currentIndex = 0;
    } else {
      this.currentIndex++;
    }
    
    this.setActiveSlide();
  }
  
  prevSlide() {
    const maxIndex = this.slidesPerView === 1 
      ? this.totalSlides - 1 
      : this.totalSlides - this.slidesPerView;
    
    if (this.currentIndex <= 0) {
      this.currentIndex = maxIndex;
    } else {
      this.currentIndex--;
    }
    
    this.setActiveSlide();
  }
  
  goToSlide(index) {
    this.currentIndex = index;
    this.setActiveSlide();
  }
  
  addEventListeners() {
    this.prevBtn.addEventListener('click', () => this.prevSlide());
    this.nextBtn.addEventListener('click', () => this.nextSlide());
    
    window.addEventListener('resize', () => {
      const oldSlidesPerView = this.slidesPerView;
      this.checkScreenSize();
      
      if (oldSlidesPerView !== this.slidesPerView) {
        this.createDots();
        
        // Adjust current index if needed
        const maxIndex = this.totalSlides - this.slidesPerView;
        if (this.currentIndex > maxIndex) {
          this.currentIndex = maxIndex;
        }
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  new TestimonialSlider();
});